module.exports = __webpack_public_path__ + "static/media/background.2df2d405.webp";